import { FC, useContext } from 'react';
import { useTitle } from 'react-use';

import { buildPageTitle } from '@savgroup-front-common/core/helpers';

import { InitContext } from '../../../../app/NewLayout/InitProvider/InitProvider.context';
import { $HomeProductsListWrapper } from '../HomePageProfessional.styles';
import messages from '../messages';

import HomePageFileItem from './HomePageFileItem/HomePageFileItem';

const HomePageFiles: FC = () => {
  const { openedFiles, closedFiles } = useContext(InitContext);

  useTitle(buildPageTitle([messages.filesTitlePage]));

  return (
    <$HomeProductsListWrapper>
      {openedFiles?.map((file) => (
        <HomePageFileItem file={file} key={file.fileId} />
      ))}
      {closedFiles?.map((file) => (
        <HomePageFileItem file={file} key={file.fileId} />
      ))}
    </$HomeProductsListWrapper>
  );
};

export default HomePageFiles;
